export const SSE_ACCOUNT_API_URL = '/api/account';
